import { loadProgressBanner } from 'sagas/network'

import { Queries } from 'api/queries.enum'

import { useQuery } from './useQuery'

export type RawProgressBannerProps = {
    createdAt: string
    text: string
}

export const useProgressBanner = () => {
    const query = useQuery<RawProgressBannerProps[], Error>({
        queryKey: [Queries.getFeedbackBanner],
        queryFn: loadProgressBanner,
    })

    return query
}
